import React, {
	createContext,
	ReactNode,
	useContext,
	useMemo,
	useState
} from 'react'

type ViewTypeCalendar = 'week' | 'month'

interface AgendaContextType {
	currentMonth: Date
	setCurrentMonth: (date: Date) => void
	currentWeek: Date
	setCurrentWeek: (date: Date) => void
	view: ViewTypeCalendar
	setView: (view: ViewTypeCalendar) => void
}

const AgendaContext = createContext<AgendaContextType | undefined>(undefined)

interface AgendaProviderProps {
	children: ReactNode
}

export const AgendaProvider: React.FC<AgendaProviderProps> = ({ children }) => {
	const today = new Date()
	const [currentMonth, setCurrentMonth] = useState<Date>(today)
	const [currentWeek, setCurrentWeek] = useState<Date>(today)
	const [view, setView] = useState<ViewTypeCalendar>('week')

	const value = useMemo(
		() => ({
			currentMonth,
			setCurrentMonth,
			currentWeek,
			setCurrentWeek,
			view,
			setView
		}),
		[currentMonth, currentWeek, view]
	)

	return (
		<AgendaContext.Provider value={value}>{children}</AgendaContext.Provider>
	)
}

export const useAgenda = (): AgendaContextType => {
	const context = useContext(AgendaContext)
	if (context === undefined) {
		throw new Error('useAgenda must be used within an AgendaProvider')
	}
	return context
}
